import script from "./MapCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MapCard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__